module.exports = "<h1>Welcome</h1>\n<p>This is the Angular front to back sandbox application</p>\n<button class=\"btn btn-secondary\" routerLink=\"/users\">Users Section</button>\n<button class=\"btn btn-dark\" routerLink=\"/posts\">Posts Section</button>"


//////////////////
// WEBPACK FOOTER
// C:/Users/markl/projects/angularapp/src/app/components/home/home.component.html
// module id = ../../../../../src/app/components/home/home.component.html
// module chunks = main